import { HeapFeatureDataStore } from "./HeapFeatureDataStore";
class AnimationHelpers {
    static playShakingAnimation(obj, { fromPositionX, fromPositionY, onStart = () => { }, onChange = () => { }, onFinish = () => { }, loop = 0, delay = 0, ease = 'linear' }) {
        const time = 100;
        const distanceX = 4;
        const distanceY = 4;

        return new Promise<void>((resolve) => {
            const _tw = {
                x: fromPositionX,
                y: fromPositionY
            };
            let _tween = null;

            game.once("game.render.ON_CHANGE_ORIENTATION", handleStopAnimation);
            function handleStopAnimation() {
                AnimationHelpers.removeTween(_tween);
                resolve();
            }

            // @ts-ignore
            _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    obj.options.position.x = _tw.x;
                    obj.options.position.y = _tw.y;
                    obj.forceViewUpdate();
                    onChange();
                },
                loop
            })
                .call(onStart.bind(this, obj))
                //Frame-1
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                //Frame-2
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                //Frame-3
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                //Frame-4
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                //Frame-5
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                //Frame-6
                .to({ x: (fromPositionX -= distanceX), y: (fromPositionY -= distanceY) }, time, createjs.Ease[ease])
                .to({ x: (fromPositionX += distanceX), y: (fromPositionY += distanceY) }, time, createjs.Ease[ease])
                .call(onFinish.bind(this, obj))
                .call(() => {
                    game.removeListener("game.render.ON_CHANGE_ORIENTATION", handleStopAnimation);
                    resolve();
                });

            obj._tween = _tween;

            return _tween;
        });
    }

    static playHardLandingAnimation(obj, { fromPositionY, onStart = () => { }, onChange = () => { }, onFinish = () => { }, loop = 0, delay = 0, ease = 'linear' }) {
        const frame1DistanceY = 10;
        const frame1TimeDown = 80;
        const frame1TimeUp = 50;

        const frame2DistanceY = 5;
        const frame2TimeDown = 50;
        const frame2TimeUp = 50;

        const frame3DistanceY = 2.5;
        const frame3TimeDown = 50;
        const frame3TimeUp = 33;

        return new Promise<void>((resolve) => {
            const _tw = {
                y: fromPositionY
            };
            let _tween = null;

            game.once("game.render.ON_CHANGE_ORIENTATION", handleStopAnimation);
            function handleStopAnimation() {
                AnimationHelpers.removeTween(_tween);
                resolve();
            }

            // @ts-ignore
            _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    obj.options.position.y = _tw.y;
                    obj.forceViewUpdate();

                    onChange();
                },
                loop
            })
                .call(onStart.bind(this, obj))
                //Frame-1
                .to({ y: (fromPositionY += frame1DistanceY) }, frame1TimeDown, createjs.Ease[ease])
                .to({ y: (fromPositionY -= frame1DistanceY) }, frame1TimeUp, createjs.Ease[ease])
                //Frame-2
                .to({ y: (fromPositionY += frame2DistanceY) }, frame2TimeDown, createjs.Ease[ease])
                .to({ y: (fromPositionY -= frame2DistanceY) }, frame2TimeUp, createjs.Ease[ease])
                //Frame-3
                .to({ y: (fromPositionY += frame3DistanceY) }, frame3TimeDown, createjs.Ease[ease])
                .to({ y: (fromPositionY -= frame3DistanceY) }, frame3TimeUp, createjs.Ease[ease])
                .call(onFinish.bind(this, obj))
                .call(() => {
                    game.removeListener("game.render.ON_CHANGE_ORIENTATION", handleStopAnimation);
                    resolve();
                });

            obj._tween = _tween;

            return _tween;
        });
    }

    static removeTween(tween) {
        game.utils.removeCall(tween);
    }

    static handleStopAnimation(tween, resolve) {
        AnimationHelpers.removeTween(tween);
        resolve();
    }

    static playAnimationWinHeap(spineElement) {
        this.setElementVisibility(spineElement, true);

        const nameAnimation = this.heapFeatureData.getCurrentNameAnimation('win');
        this.playSpineAnimation(spineElement, nameAnimation)
    }

    static playAnimationUpgrade(spineElement) {
        this.setElementVisibility(spineElement, true);

        const nameAnimation = this.heapFeatureData.getCurrentNameAnimation('upgrade');
        this.playSpineAnimation(spineElement, nameAnimation)
    }

    static playAnimationFalling(spineElement) {
        const nameAnimation = "win";

        this.setElementVisibility(spineElement, true)
        this.playSpineAnimation(spineElement, nameAnimation)
    }

    static playAnimationCollects(spineHeapElement) {
        this.playAnimationHeapCollect(spineHeapElement);
        this.playAnimationLogoCollect();
    }

    static playAnimationLogoCollect() {
        const nameAnimation = 'collect';
        const logoSpineElement = game.tree.findByName("logo_wrapper_container.logo_spine");

        this.playSpineAnimation(logoSpineElement, nameAnimation)
    }

    static playAnimationHeapCollect(spineElement) {
        this.setElementVisibility(spineElement, true);

        const nameAnimation = this.heapFeatureData.getCurrentNameAnimation('collect');
        this.playSpineAnimation(spineElement, nameAnimation)
    }

    static playSpineAnimation(element, nameAnimation) {
        if (!element || !nameAnimation) return;
        element.spine.state.setAnimation(0, nameAnimation);
    }

    static get heapFeatureData() {
        return HeapFeatureDataStore;
    }

    static setElementVisibility(element, isVisible) {
        if (!element) return;
        if (element.options.visible !== isVisible) {
            element.options.visible = isVisible;
            element.updateViewOptions();
        }
    }

    static playRotationAnimation(element, angelSpeed) {
        element.rotation += angelSpeed;
    }
}

export { AnimationHelpers }
